<template>
  <div class="basic-setting-content pl16 pr16">
    <!-- 1. 规格类型切换（绑定form.spec_type） -->
    <el-form-item label="产品规格：" prop="spec_type">
      <el-radio-group v-model="form.spec_type">
        <el-radio :label="10">单规格</el-radio>
        <el-radio :label="20">多规格</el-radio>
      </el-radio-group>
    </el-form-item>

    <!-- 2. 单规格：销售价绑定 form.sku.product_price -->
    <template v-if="Number(form.spec_type) === 10">
      <el-form-item label="销售价" prop="sku.product_price">
        <el-input 
          type="number" 
          v-model="form.sku.product_price" 
          class="max-w460"
          @input="handlePriceChange" 
        ></el-input>
      </el-form-item>
    </template>

    <!-- 3. 多规格：绑定 form.spec_many 下的属性 -->
    <template v-if="Number(form.spec_type) === 20">
      <!-- 多规格属性（如规格名称、选项） -->
      <el-form-item label="规格属性">
        <el-input 
          v-model="form.spec_many.spec_attr" 
          placeholder="请输入多规格属性（如颜色、尺寸）"
        ></el-input>
      </el-form-item>
      <!-- 多规格表格数据 -->
      <el-table v-model="form.spec_many.spec_list">
        <!-- 表格列绑定 form.spec_many.spec_list 中的字段 -->
      </el-table>
    </template>
  </div>
</template>

<script>
export default {
  inject: ["form", "updateForm"],
  methods: {
    // 可选：手动触发更新（确保响应式）
    handlePriceChange(val) {
      this.updateForm('sku.product_price', val);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/plus/supply/product/part/Spec.vue